import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
type FeatureHighlightsStripProps = {
  className?: string;
};
const HIGHLIGHTS = [{
  icon: "/water_drop.svg",
  label: "100% Waterproof"
}, {
  icon: "/handyman.svg",
  label: "Easy Installation"
}, {
  icon: "/shield_lock.svg",
  label: "Durable & Reliable"
}, {
  icon: "/weather_snowy.svg",
  label: "All-Season"
}];
export default function FeatureHighlightsStrip(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `w-fit max-w-full rounded-2xl border border-white/25 bg-black/35 px-3 py-3 backdrop-blur-glass ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ul className="m-0 grid grid-cols-2 gap-x-3 gap-y-2 p-0 text-xs font-semibold text-white/85 sm:flex sm:min-w-max sm:flex-nowrap sm:items-center sm:gap-5 sm:text-sm">{HIGHLIGHTS.map(_temp)}</ul>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t2) {
    t4 = <div className={t2}>{t3}</div>;
    $[1] = t2;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}
function _temp(item) {
  return <li key={item.label} className="flex items-center gap-2"><Image src={item.icon} alt="" width={16} height={16} aria-hidden={true} /><span className="leading-tight">{item.label}</span></li>;
}